import { API_URL } from "./config";
import { sha256Hash } from "./hashing";

export function getApiToken() {
    const apiToken = localStorage.getItem("api-token");

    if (!validateApiToken(apiToken)) {
        return [false, null];
    }

    return [true, apiToken];
}

export function hasApiToken() {
    const [loggedIn, apiToken] = getApiToken();
    if (!loggedIn)
        return false;

    if (!validateApiToken(apiToken))
        return false;

    return true;
}

export function hasApiTokenExpired() {
    const expiresAt = localStorage.getItem("api-token-expires-at");
    if (!expiresAt) {
        return false;
    }

    const expiresAtValue = parseInt(expiresAt);
    if (!expiresAtValue) {
        return false;
    }

    const currentTime = Math.round(Date.now() / 1000);

    return currentTime > expiresAtValue;
}

function validateApiToken(apiToken) {
    if (!apiToken) {
        return false;
    }

    if (!apiToken.startsWith("Bearer ")) {
        return false;
    }

    return true;
}

export function removeApiToken() {
    localStorage.removeItem("api-token");
    localStorage.removeItem("api-token-expires-at");
}

export function storeApiToken(token, expiresAt) {
    localStorage.setItem("api-token", token);
    localStorage.setItem("api-token-expires-at", expiresAt);
}

export async function authenticateApiTokenWithAccessKey(accessKey) {
    try {
        const hash = await sha256Hash(accessKey);

        const credentials = {
            accessKey: hash,
        };
        const response = await fetch(`${API_URL}/api/auth-api-token-with-accesskey`, {
            method: "POST",
            body: JSON.stringify(credentials),
            headers: {
                "Content-Type": "application/json",
            },
        });

        if (response.status !== 200) {
            const error = await response.text();
            return [false, null, null, error];
        }

        const {token, expiresAt} = await response.json();

        if (!validateApiToken(token)) {
            return [false, null, null, "Invalid api token response"];
        }
        
        return [true, token, expiresAt, null];
    }
    catch {
        return [false, null, null, "Failed to authenticate"];
    }
}